// Depth band labels for the Settings card, rendered live as the owner types.
//
// A copy of depthTenths / depthBandLabel in server/services/pricing.js, which
// is the authority: the server writes these labels into stop locks and the
// public matrix. depthBands.test.js runs both over the same inputs so the two
// cannot drift apart.
//
// Depths are handled in tenths of an inch, as integers, never as floats.

export const DEFAULT_DEPTH_BAND_EDGES = [3.0, 6.0, 9.0, 12.0, null];

// 3.04 -> 30, 3.05 -> 31 (half away from zero). null, undefined, '' and NaN -> null.
export const depthTenths = (inches) => {
  if (inches === null || inches === undefined || inches === '') return null;
  const v = typeof inches === 'number' ? inches : parseFloat(inches);
  if (!Number.isFinite(v)) return null;
  const t = Math.round(Math.abs(v) * 10 + 1e-9);
  return v < 0 ? -t : t;
};

const inchesText = (tenths) => (tenths % 10 === 0 ? String(tenths / 10) : (tenths / 10).toFixed(1));

// '0-3 in', '3.1-6 in', '12.1+ in'. sortedBands are [{ upperInches }] in order.
export const depthBandLabel = (sortedBands, index) => {
  const band = sortedBands[index] || {};
  const prev = index > 0 ? sortedBands[index - 1] : null;
  const lower = prev ? depthTenths(prev.upperInches) + 1 : 0;
  const upper = depthTenths(band.upperInches);
  return upper === null
    ? `${inchesText(lower)}+ in`
    : `${inchesText(lower)}-${inchesText(upper)} in`;
};

// The client's own check of the edge inputs, so a bad edge is flagged before
// saving. The server's validateDepthBands is the one that decides.
export const bandEdgeErrors = (edges) => {
  const errors = [];
  let prev = null;
  edges.forEach((edge, i) => {
    if (i === edges.length - 1) return; // the last band is always open
    const t = depthTenths(edge);
    if (t === null || t <= 0) errors.push(`Band ${i + 1} needs an upper edge above 0.`);
    else if (Math.abs(parseFloat(edge) * 10 - t) > 1e-6) errors.push(`Band ${i + 1}: use tenths of an inch.`);
    else if (prev !== null && t <= prev) errors.push(`Band ${i + 1} must be higher than band ${i}.`);
    if (t !== null) prev = t;
  });
  return errors;
};
